/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumChatActivityReason = "noFurtherAction" | "notActionable" | "notRelevant" | "offensive" | "other" | "spam" | "%future added value";
export type EnumChatActivityStatus = "assigned" | "closed" | "pending" | "unassigned" | "%future added value";
export type FilterChatActivityInput = {
    user?: string | null | undefined;
    _id?: string | null | undefined;
    deleted?: number | null | undefined;
    createdAt?: unknown | null | undefined;
    updatedAt?: unknown | null | undefined;
    createdBy?: string | null | undefined;
    updatedBy?: string | null | undefined;
    deletedBy?: string | null | undefined;
    deletedAt?: unknown | null | undefined;
    to?: string | null | undefined;
    patient?: string | null | undefined;
    lastMessage?: string | null | undefined;
    unreadMessages?: number | null | undefined;
    status?: EnumChatActivityStatus | null | undefined;
    assignee?: string | null | undefined;
    groupAssignee?: string | null | undefined;
    previousAssignee?: string | null | undefined;
    previousGroupAssignee?: string | null | undefined;
    reason?: EnumChatActivityReason | null | undefined;
    statusReason?: unknown | null | undefined;
    description?: string | null | undefined;
    facilities?: Array<string | null> | null | undefined;
    priorityUpdatedAt?: unknown | null | undefined;
    lastIrregularAt?: unknown | null | undefined;
    automated?: boolean | null | undefined;
    _ids?: Array<string | null> | null | undefined;
    _operators?: OperatorsFilterChatActivityInput | null | undefined;
    OR?: Array<FilterChatActivityInput> | null | undefined;
    AND?: Array<FilterChatActivityInput> | null | undefined;
};
export type OperatorsFilterChatActivityInput = {
    user?: UserOperatorsFilterChatActivityInput | null | undefined;
    _id?: _idOperatorsFilterChatActivityInput | null | undefined;
    deleted?: DeletedOperatorsFilterChatActivityInput | null | undefined;
    createdAt?: CreatedAtOperatorsFilterChatActivityInput | null | undefined;
    updatedAt?: UpdatedAtOperatorsFilterChatActivityInput | null | undefined;
    createdBy?: CreatedByOperatorsFilterChatActivityInput | null | undefined;
    updatedBy?: UpdatedByOperatorsFilterChatActivityInput | null | undefined;
    deletedBy?: DeletedByOperatorsFilterChatActivityInput | null | undefined;
    deletedAt?: DeletedAtOperatorsFilterChatActivityInput | null | undefined;
    to?: ToOperatorsFilterChatActivityInput | null | undefined;
    patient?: PatientOperatorsFilterChatActivityInput | null | undefined;
    lastMessage?: LastMessageOperatorsFilterChatActivityInput | null | undefined;
    unreadMessages?: UnreadMessagesOperatorsFilterChatActivityInput | null | undefined;
    status?: StatusOperatorsFilterChatActivityInput | null | undefined;
    assignee?: AssigneeOperatorsFilterChatActivityInput | null | undefined;
    groupAssignee?: GroupAssigneeOperatorsFilterChatActivityInput | null | undefined;
    previousAssignee?: PreviousAssigneeOperatorsFilterChatActivityInput | null | undefined;
    previousGroupAssignee?: PreviousGroupAssigneeOperatorsFilterChatActivityInput | null | undefined;
    reason?: ReasonOperatorsFilterChatActivityInput | null | undefined;
    statusReason?: StatusReasonOperatorsFilterChatActivityInput | null | undefined;
    description?: DescriptionOperatorsFilterChatActivityInput | null | undefined;
    facilities?: FacilitiesOperatorsFilterChatActivityInput | null | undefined;
    priorityUpdatedAt?: PriorityUpdatedAtOperatorsFilterChatActivityInput | null | undefined;
    lastIrregularAt?: LastIrregularAtOperatorsFilterChatActivityInput | null | undefined;
    automated?: AutomatedOperatorsFilterChatActivityInput | null | undefined;
};
export type UserOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type _idOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedOperatorsFilterChatActivityInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type CreatedAtOperatorsFilterChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type UpdatedAtOperatorsFilterChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type CreatedByOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UpdatedByOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedByOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedAtOperatorsFilterChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type ToOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PatientOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type LastMessageOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UnreadMessagesOperatorsFilterChatActivityInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type StatusOperatorsFilterChatActivityInput = {
    gt?: EnumChatActivityStatus | null | undefined;
    gte?: EnumChatActivityStatus | null | undefined;
    lt?: EnumChatActivityStatus | null | undefined;
    lte?: EnumChatActivityStatus | null | undefined;
    ne?: EnumChatActivityStatus | null | undefined;
    in?: Array<EnumChatActivityStatus | null> | null | undefined;
    nin?: Array<EnumChatActivityStatus | null> | null | undefined;
    regex?: EnumChatActivityStatus | null | undefined;
};
export type AssigneeOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type GroupAssigneeOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PreviousAssigneeOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PreviousGroupAssigneeOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ReasonOperatorsFilterChatActivityInput = {
    gt?: EnumChatActivityReason | null | undefined;
    gte?: EnumChatActivityReason | null | undefined;
    lt?: EnumChatActivityReason | null | undefined;
    lte?: EnumChatActivityReason | null | undefined;
    ne?: EnumChatActivityReason | null | undefined;
    in?: Array<EnumChatActivityReason | null> | null | undefined;
    nin?: Array<EnumChatActivityReason | null> | null | undefined;
    regex?: EnumChatActivityReason | null | undefined;
};
export type StatusReasonOperatorsFilterChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type DescriptionOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FacilitiesOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PriorityUpdatedAtOperatorsFilterChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type LastIrregularAtOperatorsFilterChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type AutomatedOperatorsFilterChatActivityInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type FilterFindManyChatActivityInput = {
    user?: string | null | undefined;
    _id?: string | null | undefined;
    deleted?: number | null | undefined;
    createdAt?: unknown | null | undefined;
    updatedAt?: unknown | null | undefined;
    createdBy?: string | null | undefined;
    updatedBy?: string | null | undefined;
    deletedBy?: string | null | undefined;
    deletedAt?: unknown | null | undefined;
    to?: string | null | undefined;
    patient?: string | null | undefined;
    lastMessage?: string | null | undefined;
    unreadMessages?: number | null | undefined;
    status?: EnumChatActivityStatus | null | undefined;
    assignee?: string | null | undefined;
    groupAssignee?: string | null | undefined;
    previousAssignee?: string | null | undefined;
    previousGroupAssignee?: string | null | undefined;
    reason?: EnumChatActivityReason | null | undefined;
    statusReason?: unknown | null | undefined;
    description?: string | null | undefined;
    facilities?: Array<string | null> | null | undefined;
    priorityUpdatedAt?: unknown | null | undefined;
    lastIrregularAt?: unknown | null | undefined;
    automated?: boolean | null | undefined;
    _ids?: Array<string | null> | null | undefined;
    _operators?: OperatorsFilterFindManyChatActivityInput | null | undefined;
    OR?: Array<FilterFindManyChatActivityInput> | null | undefined;
    AND?: Array<FilterFindManyChatActivityInput> | null | undefined;
};
export type OperatorsFilterFindManyChatActivityInput = {
    user?: UserOperatorsFilterFindManyChatActivityInput | null | undefined;
    _id?: _idOperatorsFilterFindManyChatActivityInput | null | undefined;
    deleted?: DeletedOperatorsFilterFindManyChatActivityInput | null | undefined;
    createdAt?: CreatedAtOperatorsFilterFindManyChatActivityInput | null | undefined;
    updatedAt?: UpdatedAtOperatorsFilterFindManyChatActivityInput | null | undefined;
    createdBy?: CreatedByOperatorsFilterFindManyChatActivityInput | null | undefined;
    updatedBy?: UpdatedByOperatorsFilterFindManyChatActivityInput | null | undefined;
    deletedBy?: DeletedByOperatorsFilterFindManyChatActivityInput | null | undefined;
    deletedAt?: DeletedAtOperatorsFilterFindManyChatActivityInput | null | undefined;
    to?: ToOperatorsFilterFindManyChatActivityInput | null | undefined;
    patient?: PatientOperatorsFilterFindManyChatActivityInput | null | undefined;
    lastMessage?: LastMessageOperatorsFilterFindManyChatActivityInput | null | undefined;
    unreadMessages?: UnreadMessagesOperatorsFilterFindManyChatActivityInput | null | undefined;
    status?: StatusOperatorsFilterFindManyChatActivityInput | null | undefined;
    assignee?: AssigneeOperatorsFilterFindManyChatActivityInput | null | undefined;
    groupAssignee?: GroupAssigneeOperatorsFilterFindManyChatActivityInput | null | undefined;
    previousAssignee?: PreviousAssigneeOperatorsFilterFindManyChatActivityInput | null | undefined;
    previousGroupAssignee?: PreviousGroupAssigneeOperatorsFilterFindManyChatActivityInput | null | undefined;
    reason?: ReasonOperatorsFilterFindManyChatActivityInput | null | undefined;
    statusReason?: StatusReasonOperatorsFilterFindManyChatActivityInput | null | undefined;
    description?: DescriptionOperatorsFilterFindManyChatActivityInput | null | undefined;
    facilities?: FacilitiesOperatorsFilterFindManyChatActivityInput | null | undefined;
    priorityUpdatedAt?: PriorityUpdatedAtOperatorsFilterFindManyChatActivityInput | null | undefined;
    lastIrregularAt?: LastIrregularAtOperatorsFilterFindManyChatActivityInput | null | undefined;
    automated?: AutomatedOperatorsFilterFindManyChatActivityInput | null | undefined;
};
export type UserOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type _idOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedOperatorsFilterFindManyChatActivityInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type CreatedAtOperatorsFilterFindManyChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type UpdatedAtOperatorsFilterFindManyChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type CreatedByOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UpdatedByOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedByOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedAtOperatorsFilterFindManyChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type ToOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PatientOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type LastMessageOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UnreadMessagesOperatorsFilterFindManyChatActivityInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type StatusOperatorsFilterFindManyChatActivityInput = {
    gt?: EnumChatActivityStatus | null | undefined;
    gte?: EnumChatActivityStatus | null | undefined;
    lt?: EnumChatActivityStatus | null | undefined;
    lte?: EnumChatActivityStatus | null | undefined;
    ne?: EnumChatActivityStatus | null | undefined;
    in?: Array<EnumChatActivityStatus | null> | null | undefined;
    nin?: Array<EnumChatActivityStatus | null> | null | undefined;
    regex?: EnumChatActivityStatus | null | undefined;
};
export type AssigneeOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type GroupAssigneeOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PreviousAssigneeOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PreviousGroupAssigneeOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ReasonOperatorsFilterFindManyChatActivityInput = {
    gt?: EnumChatActivityReason | null | undefined;
    gte?: EnumChatActivityReason | null | undefined;
    lt?: EnumChatActivityReason | null | undefined;
    lte?: EnumChatActivityReason | null | undefined;
    ne?: EnumChatActivityReason | null | undefined;
    in?: Array<EnumChatActivityReason | null> | null | undefined;
    nin?: Array<EnumChatActivityReason | null> | null | undefined;
    regex?: EnumChatActivityReason | null | undefined;
};
export type StatusReasonOperatorsFilterFindManyChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type DescriptionOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FacilitiesOperatorsFilterFindManyChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PriorityUpdatedAtOperatorsFilterFindManyChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type LastIrregularAtOperatorsFilterFindManyChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type AutomatedOperatorsFilterFindManyChatActivityInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type QueryListChatActivitiesRefresh_EmbedQueryVariables = {
    includeChatActivity?: boolean | null | undefined;
    includeAssignee?: boolean | null | undefined;
    filterCount: FilterChatActivityInput;
    filter: FilterFindManyChatActivityInput;
};
export type QueryListChatActivitiesRefresh_EmbedQueryResponse = {
    readonly chatActivityMany: ReadonlyArray<{
        readonly id: string;
        readonly _id: string;
        readonly deleted: number | null;
        readonly readByUser: boolean | null;
        readonly oid_patient: string | null;
        readonly oid_assignee: string | null;
        readonly oid_groupAssignee: string | null;
        readonly patient: {
            readonly _id: string;
            readonly " $fragmentRefs": FragmentRefs<"ActionsPatient_EmbedPatient">;
        } | null;
        readonly status: EnumChatActivityStatus | null;
        readonly assignee: {
            readonly _id: string;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"ListItemChatActivity_EmbedChatActivity">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"TypographyChatActivityCount_EmbedQuery">;
};
export type QueryListChatActivitiesRefresh_EmbedQuery = {
    readonly response: QueryListChatActivitiesRefresh_EmbedQueryResponse;
    readonly variables: QueryListChatActivitiesRefresh_EmbedQueryVariables;
};



/*
query QueryListChatActivitiesRefresh_EmbedQuery(
  $includeChatActivity: Boolean = true
  $includeAssignee: Boolean = true
  $filterCount: FilterChatActivityInput!
  $filter: FilterFindManyChatActivityInput!
) {
  ...TypographyChatActivityCount_EmbedQuery_4lIpJ9
  chatActivityMany(filter: $filter) {
    id
    _id
    deleted
    readByUser
    oid_patient
    oid_assignee
    oid_groupAssignee
    ...ListItemChatActivity_EmbedChatActivity_36zdle
    patient {
      _id
      ...ActionsPatient_EmbedPatient_DlB6l
      id
    }
    status
    assignee {
      _id
      id
    }
  }
}

fragment ActionsPatient_EmbedPatient_DlB6l on Patient {
  _id
  contact {
    type
    active
  }
  chatActivity @include(if: $includeChatActivity) {
    _id
    status
    assignee {
      _id
      id
    }
    groupAssignee {
      _id
      id
    }
    ...AvatarChatActivityReassign_EmbedChatActivity
    id
  }
  ...IconButtonPatientActions_EmbedPatient_DlB6l
}

fragment AvatarChatActivityReassign_EmbedChatActivity on ChatActivity {
  _id
  assignee {
    ...AvatarNode_EmbedNode
    id
  }
  groupAssignee {
    ...AvatarNode_EmbedNode
    id
  }
}

fragment AvatarNode_EmbedNode on Node {
  __isNode: __typename
  __typename
  ... on Group {
    groupName: name
  }
  ... on Patient {
    name
    oid_avatar
    isOnline
  }
  ... on Provider {
    name
    oid_avatar
    isOnline
  }
  ... on User {
    name
    oid_avatar
    isOnline
  }
  ... on ChatActivity {
    patient {
      name
      oid_avatar
      isOnline
      id
    }
  }
}

fragment IconButtonPatientActions_EmbedPatient_DlB6l on Patient {
  _id
  chatActivity @include(if: $includeChatActivity) {
    _id
    status
    assignee {
      _id
      id
    }
    groupAssignee {
      _id
      id
    }
    id
  }
}

fragment ListItemChatActivity_EmbedChatActivity_36zdle on ChatActivity {
  _id
  patient {
    _id
    firstname
    lastname
    id
  }
  ...AvatarNode_EmbedNode
  ...TypographyChatActivityLastMessage_EmbedChatActivity
  ...TypographyChatActivityUpdatedAt_EmbedChatActivity
  ...AvatarChatActivityReassign_EmbedChatActivity @include(if: $includeAssignee)
}

fragment TypographyChatActivityCount_EmbedQuery_4lIpJ9 on Query {
  chatActivityCount(filter: $filterCount)
}

fragment TypographyChatActivityLastMessage_EmbedChatActivity on ChatActivity {
  lastMessage {
    ...TypographyMessageText_EmbedMessage
    id
  }
}

fragment TypographyChatActivityUpdatedAt_EmbedChatActivity on ChatActivity {
  updatedAt
}

fragment TypographyMessageText_EmbedMessage on Message {
  text
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterCount"
},
v2 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "includeAssignee"
},
v3 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "includeChatActivity"
},
v4 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deleted",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readByUser",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_patient",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_assignee",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_groupAssignee",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v13 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filterCount"
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "groupName",
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Group",
  "abstractKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_avatar",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOnline",
  "storageKey": null
},
v19 = [
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "Patient",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "Provider",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "User",
  "abstractKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Patient",
          "kind": "LinkedField",
          "name": "patient",
          "plural": false,
          "selections": [
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ChatActivity",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v24 = [
  (v6/*: any*/),
  (v5/*: any*/),
  (v23/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QueryListChatActivitiesRefresh_EmbedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "ChatActivity",
        "kind": "LinkedField",
        "name": "chatActivityMany",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Patient",
            "kind": "LinkedField",
            "name": "patient",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "includeChatActivity",
                    "variableName": "includeChatActivity"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "ActionsPatient_EmbedPatient"
              }
            ],
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "assignee",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "includeAssignee",
                "variableName": "includeAssignee"
              }
            ],
            "kind": "FragmentSpread",
            "name": "ListItemChatActivity_EmbedChatActivity"
          }
        ],
        "storageKey": null
      },
      {
        "args": (v13/*: any*/),
        "kind": "FragmentSpread",
        "name": "TypographyChatActivityCount_EmbedQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "QueryListChatActivitiesRefresh_EmbedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v13/*: any*/),
        "kind": "ScalarField",
        "name": "chatActivityCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "ChatActivity",
        "kind": "LinkedField",
        "name": "chatActivityMany",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Patient",
            "kind": "LinkedField",
            "name": "patient",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstname",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastname",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PatientContact",
                "kind": "LinkedField",
                "name": "contact",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "active",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "includeChatActivity",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChatActivity",
                    "kind": "LinkedField",
                    "name": "chatActivity",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "assignee",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Group",
                        "kind": "LinkedField",
                        "name": "groupAssignee",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Message",
            "kind": "LinkedField",
            "name": "lastMessage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "assignee",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Patient",
                    "kind": "LinkedField",
                    "name": "patient",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "ChatActivity",
                "abstractKey": null
              }
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          },
          {
            "condition": "includeAssignee",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "assignee",
                "plural": false,
                "selections": [
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Group",
                "kind": "LinkedField",
                "name": "groupAssignee",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c4155d57aca3d50ecbb472ffa84b5869",
    "id": null,
    "metadata": {},
    "name": "QueryListChatActivitiesRefresh_EmbedQuery",
    "operationKind": "query",
    "text": "query QueryListChatActivitiesRefresh_EmbedQuery(\n  $includeChatActivity: Boolean = true\n  $includeAssignee: Boolean = true\n  $filterCount: FilterChatActivityInput!\n  $filter: FilterFindManyChatActivityInput!\n) {\n  ...TypographyChatActivityCount_EmbedQuery_4lIpJ9\n  chatActivityMany(filter: $filter) {\n    id\n    _id\n    deleted\n    readByUser\n    oid_patient\n    oid_assignee\n    oid_groupAssignee\n    ...ListItemChatActivity_EmbedChatActivity_36zdle\n    patient {\n      _id\n      ...ActionsPatient_EmbedPatient_DlB6l\n      id\n    }\n    status\n    assignee {\n      _id\n      id\n    }\n  }\n}\n\nfragment ActionsPatient_EmbedPatient_DlB6l on Patient {\n  _id\n  contact {\n    type\n    active\n  }\n  chatActivity @include(if: $includeChatActivity) {\n    _id\n    status\n    assignee {\n      _id\n      id\n    }\n    groupAssignee {\n      _id\n      id\n    }\n    ...AvatarChatActivityReassign_EmbedChatActivity\n    id\n  }\n  ...IconButtonPatientActions_EmbedPatient_DlB6l\n}\n\nfragment AvatarChatActivityReassign_EmbedChatActivity on ChatActivity {\n  _id\n  assignee {\n    ...AvatarNode_EmbedNode\n    id\n  }\n  groupAssignee {\n    ...AvatarNode_EmbedNode\n    id\n  }\n}\n\nfragment AvatarNode_EmbedNode on Node {\n  __isNode: __typename\n  __typename\n  ... on Group {\n    groupName: name\n  }\n  ... on Patient {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on Provider {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on User {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on ChatActivity {\n    patient {\n      name\n      oid_avatar\n      isOnline\n      id\n    }\n  }\n}\n\nfragment IconButtonPatientActions_EmbedPatient_DlB6l on Patient {\n  _id\n  chatActivity @include(if: $includeChatActivity) {\n    _id\n    status\n    assignee {\n      _id\n      id\n    }\n    groupAssignee {\n      _id\n      id\n    }\n    id\n  }\n}\n\nfragment ListItemChatActivity_EmbedChatActivity_36zdle on ChatActivity {\n  _id\n  patient {\n    _id\n    firstname\n    lastname\n    id\n  }\n  ...AvatarNode_EmbedNode\n  ...TypographyChatActivityLastMessage_EmbedChatActivity\n  ...TypographyChatActivityUpdatedAt_EmbedChatActivity\n  ...AvatarChatActivityReassign_EmbedChatActivity @include(if: $includeAssignee)\n}\n\nfragment TypographyChatActivityCount_EmbedQuery_4lIpJ9 on Query {\n  chatActivityCount(filter: $filterCount)\n}\n\nfragment TypographyChatActivityLastMessage_EmbedChatActivity on ChatActivity {\n  lastMessage {\n    ...TypographyMessageText_EmbedMessage\n    id\n  }\n}\n\nfragment TypographyChatActivityUpdatedAt_EmbedChatActivity on ChatActivity {\n  updatedAt\n}\n\nfragment TypographyMessageText_EmbedMessage on Message {\n  text\n}\n"
  }
};
})();
(node as any).hash = '001f951fdb35ff42c94e6e17b4339cd5';
export default node;
